import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest, postRequest, putRequest } from "../../services";
import {
  decryptMessage,
  encryptMessage,
} from "../../services/encryption.decryption";
import toaster from "../../utilities/toaster";
import dateFormat from "../../utilities/dateFormat";

export const getUserTypeData = createAsyncThunk(
  "USERS/getUserType",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getRank = createAsyncThunk(
  "USERS/getRank",
  ({ endPoint }: { endPoint: String }) => {
    return postRequest(endPoint, { shift: "day" })
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getAllUserData = createAsyncThunk(
  "USERS/getAllUser",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getOperatorTypeData = createAsyncThunk(
  "USERS/getOperatorType",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getStaffTypeData = createAsyncThunk(
  "USERS/getStaffType",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const subContractorTypeData = createAsyncThunk(
  "USERS/getSubContractorType",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const postAddUserData = createAsyncThunk(
  "USERS/postData",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const putUserData = createAsyncThunk(
  "USERS/putData",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const putData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return putRequest(endPoint, putData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const deleteUserData = createAsyncThunk(
  "USERS/deleteUser",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const putData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return putRequest(endPoint, putData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const postForgotPasswordData = createAsyncThunk(
  "USERS/postForgotPasswordData",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getAvailableMachines = createAsyncThunk(
  "Users/Available Machines",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getUserAULogs = createAsyncThunk(
  "USERS/getUserLogs",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getUsersByTypeAndProject = createAsyncThunk(
  "USERS/by type and project",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

type SliceState = {
  loading: boolean;
  JwtToken: string;
  userTypeData: null | "" | Object;
  allUserData: null | "" | Object;
  delUserData: null | "" | Object;
  addUserData: null | "" | Object;
  editUserData: null | "" | Object;
  forgotPasswordData: null | "" | Object;
  operatorType: null | "" | Object;
  staffType: null | "" | Object;
  subContractorType: null | "" | Object;
  availableMachines: null | "" | Object;
  userAULogs: null | "" | Object;
  ranks: null | "" | Object;
  userByTypeAndProject: null | "" | Object;
};

const initialState: SliceState = {
  loading: false,
  JwtToken: "",
  userTypeData: "",
  allUserData: [],
  delUserData: "",
  addUserData: "",
  editUserData: "",
  forgotPasswordData: "",
  operatorType: "",
  staffType: "",
  subContractorType: "",
  availableMachines: [],
  userAULogs: [],
  ranks: [],
  userByTypeAndProject: [],
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setToken(state, action) {
      state.JwtToken = action.payload;
    },
  },
  extraReducers: (builder) => {
    //TODO: Get API CALL START
    builder.addCase(getUserTypeData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserTypeData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.userTypeData = data?.data[0]?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getUserTypeData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getAllUserData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllUserData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.allUserData = data?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getAllUserData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Put API CALL START
    builder.addCase(putUserData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(putUserData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        toaster("success", data?.message);
        state.editUserData = data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(putUserData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Put API CALL END

    //TODO: Post API CALL START
    builder.addCase(postAddUserData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postAddUserData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        toaster("success", data?.message);
        state.addUserData = data;
      } else {
        toaster("error", data?.message);
        console.log(data);
      }
    });
    builder.addCase(postAddUserData.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL END

    //TODO: Put API CALL START
    builder.addCase(deleteUserData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteUserData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        toaster("success", data?.message);
        state.delUserData = data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(deleteUserData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Put API CALL END

    //TODO: Post API CALL START
    builder.addCase(postForgotPasswordData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postForgotPasswordData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        toaster("success", data?.message);
        state.forgotPasswordData = data;
      } else {
        toaster("error", data?.message);
        console.log(data);
      }
    });
    builder.addCase(postForgotPasswordData.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL END

    //TODO: Get API CALL START
    builder.addCase(getOperatorTypeData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOperatorTypeData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.operatorType = data?.data[0]?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getOperatorTypeData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getStaffTypeData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStaffTypeData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.staffType = data?.data[0]?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getStaffTypeData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(subContractorTypeData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(subContractorTypeData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.subContractorType = data?.data[0]?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(subContractorTypeData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getUserAULogs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserAULogs.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.userAULogs = data?.data?.map((val: any) => ({
          ...val,
          from: dateFormat(val?.from?.slice(0, 10)),
          to: dateFormat(val?.to?.slice(0, 10)),
          project: val?.project?.name,
        }));
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getUserAULogs.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    builder.addCase(getRank.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getRank.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRank.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.ranks = data?.data;
      } else {
        console.log(data?.status);
      }
    });
    //RANK: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getUsersByTypeAndProject.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUsersByTypeAndProject.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.userByTypeAndProject = data?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getUsersByTypeAndProject.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
  },
});

export const uiUsersActions = usersSlice.actions;

export default usersSlice;
